var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_close_pop")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "set-box_1",
    transform: "translate(-851.000000, -115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(842.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_close_pop",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,0 L10.6666667,0 C13.6121853,-5.41083001e-16 16,2.38781467 16,5.33333333 L16,10.6666667 C16,13.6121853 13.6121853,16 10.6666667,16 L5.33333333,16 C2.38781467,16 3.60722001e-16,13.6121853 0,10.6666667 L0,5.33333333 C-3.60722001e-16,2.38781467 2.38781467,5.41083001e-16 5.33333333,0 Z",
    id: "\\u77E9\\u5F62",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(1.000000, 1.000000)",
    fill: "#3B199F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.699607173,5.90005612 L14.6996072,5.90005612 C15.3070894,5.90005612 15.7995511,6.39251777 15.7995511,7 C15.7995511,7.60748223 15.3070894,8.09994388 14.6996072,8.09994388 L-0.699607173,8.09994388 C-1.3070894,8.09994388 -1.79955105,7.60748223 -1.79955105,7 C-1.79955105,6.39251777 -1.3070894,5.90005612 -0.699607173,5.90005612 Z",
    id: "\\u77E9\\u5F62",
    transform: "translate(7.000000, 7.000000) rotate(-315.000000) translate(-7.000000, -7.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.699607173,5.90005612 L14.6996072,5.90005612 C15.3070894,5.90005612 15.7995511,6.39251777 15.7995511,7 C15.7995511,7.60748223 15.3070894,8.09994388 14.6996072,8.09994388 L-0.699607173,8.09994388 C-1.3070894,8.09994388 -1.79955105,7.60748223 -1.79955105,7 C-1.79955105,6.39251777 -1.3070894,5.90005612 -0.699607173,5.90005612 Z",
    id: "\\u77E9\\u5F62",
    transform: "translate(7.000000, 7.000000) rotate(-45.000000) translate(-7.000000, -7.000000) "
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_close.bedfe835.svg";
export { ForwardRef as ReactComponent };